<script lang="ts" setup>
import camera from "@/assets/image/icons/camera-xs.svg";
import house from "@/assets/image/icons/house-xs.svg";
import solar from "@/assets/image/icons/solar-xs.svg";
import electrical from "@/assets/image/icons/electrical-xs.svg";
import ElectricalInstallationsSm from "@/assets/image/hero/hero-card-elektro-mobile.png";
import ElectricalInstallations from "@/assets/image/hero/hero-elektroinstalacija.png";
import SolarPanels from "@/assets/image/hero/hero-solarni-paneli.png";
import SolarPanelsSm from "@/assets/image/hero/carousel-solar-projektovanje.png";
import VideoSurveillance from "@/assets/image/hero/hero-video-nadzor.png";
import HeatPumps from "@/assets/image/hero/hero-pumpe.png";
import HeatPumpsSm from "@/assets/image/hero/carousel-pumpe-ugradnja.png";
import airConditioning from "@/assets/image/hero/hero-klimatizacija.png";
import climate from "@/assets/image/icons/climate_mini_split.svg";
import { useDefaultStore } from "@/store";
import { $t } from "@/i18n";
import type { RouteName } from "@/router";

const store = useDefaultStore();
const hoverTimeout = ref<number | null>(null);
const activeIndex = ref(0);

const cards = computed(() => [
  {
    id: 1,
    icon: solar,
    routeName: "SolarPanelsPage" as RouteName,
    image: SolarPanels,
    smImage: SolarPanelsSm,
    text: $t("app.homePage.hero.cards.solarPanels"),
    active: true,
  },
  {
    id: 2,
    icon: camera,
    routeName: "VideoSurveillancePage" as RouteName,
    image: VideoSurveillance,
    text: $t("app.homePage.hero.cards.videoSurveillance"),
    active: false,
  },
  {
    id: 3,
    icon: electrical,
    routeName: "ElectricalInstallationsPage" as RouteName,
    image: ElectricalInstallations,
    smImage: ElectricalInstallationsSm,
    text: $t("app.homePage.hero.cards.electricalInstallations"),
    active: false,
  },
  {
    id: 4,
    icon: house,
    routeName: "HeatPumpsPage" as RouteName,
    image: HeatPumps,
    smImage: HeatPumpsSm,
    text: $t("app.homePage.hero.cards.heatPumps"),
    active: false,
  },
  {
    id: 5,
    icon: climate,
    routeName: "AirConditioning" as RouteName,
    image: airConditioning,
    text: $t("app.homePage.hero.cards.airConditioning"),
    active: false,
  },
]);

const setActive = (i: number) => {
  activeIndex.value = i;
};

const handleMouseEnter = (i: number) => {
  if (hoverTimeout.value) clearTimeout(hoverTimeout.value);

  hoverTimeout.value = globalThis.setTimeout(() => {
    setActive(i);
  }, 300);
};
</script>

<template>
  <m-hero class="bg-text-dark py-4 md:pt-0 md:pb-12 [@media(min-width:1307px)]:flex [@media(min-width:1307px)]:justify-center">
    <div v-if="!store.isWiderThan1307" class="aspect-[101/100] [@media(min-width:1307px)]:aspect-auto [@media(min-width:1307px)]:h-[892px]">
      <carousel-comp :carousel="cards">
        <template #default="{ item, active }">
          <hero-card
            :background="item?.smImage ? item.smImage : item.image"
            :text="item.text ?? ''"
            :active="active"
            :icon="item.icon ?? ''"
            :route-name="item.routeName ?? ''"
          />
        </template>
      </carousel-comp>
    </div>

    <div
      v-else
      class="flex h-[892px] w-full max-w-[1275px] space-x-1 overflow-hidden transition-transform duration-300 ease-in-out will-change-transform"
    >
      <hero-card
        v-for="(card, i) in cards"
        :key="card.id"
        :background="card.image"
        :text="card.text"
        :active="i === activeIndex"
        :icon="card.icon"
        :route-name="card.routeName"
        @click="setActive(i)"
        @mouseenter="handleMouseEnter(i)"
      />
    </div>
  </m-hero>
</template>
